/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('MainController', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', '$timeout', '$sce', function ($rootScope, $scope, $http, NetworkService, MainService, Notification, $timeout, $sce) {


    $scope.monitor = "Monitor1";
    $scope.key = "1234"
    $scope.data = ""

    $scope.startPoll = function()
    {

      /*NetworkService.getMonitorData($scope.monitor, $scope.key, "checksummPlaceholder", function (data) {
        $scope.data = data.data;
      })*/

      setInterval(function(){
        NetworkService.getMonitorData($scope.monitor, $scope.key, "checksummPlaceholder", function (data) {
          $scope.data = $sce.trustAsHtml(data.data);
        })
      },500)
    }

      $scope.register = function()
      {
        NetworkService.registerMonitor($scope.monitor, $scope.key, function (data) {
          console.log("registered")
          $scope.startPoll()
        })
      }
        $scope.init = function ()
        {
            $scope.register()
        }

        $scope.init()
    }])
